import { enUS, fr } from 'date-fns/locale';

// Get the appropriate locale for date-fns based on current language
export const getDateFnsLocale = (language: string) => {
  switch (language) {
    case 'fr':
      return fr;
    case 'en':
    default:
      return enUS;
  }
};

// Get the appropriate locale for other libraries based on current language
export const getLocale = (language: string) => {
  switch (language) {
    case 'fr':
      return 'fr-FR';
    case 'en':
    default:
      return 'en-US';
  }
};

// Check if the current language is French
export const isFrench = (language: string) => {
  return language === 'fr';
};

// Check if the current language is English
export const isEnglish = (language: string) => {
  return language === 'en';
}; 